<template>
  <div class="user-table-container">
    <div class="search-bar">
      <input type="text" placeholder="用户名：请输入用户名" v-model="searchUsername" />
      <input type="text" placeholder="邮箱：请输入邮箱" v-model="searchEmail" />
      <button class="search-button" @click="search">搜索</button>
      <button class="clear-button" @click="clear">清空</button>
      <button class="add-admin-button" @click="openAddAdminModal">添加管理员</button>
    </div>
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>用户名</th>
          <th>是否管理员</th>
          <th>部门</th>
          <th>真实姓名</th>
          <th>手机号</th>
          <th>邮箱</th>
          <th>状态</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in filteredUsers" :key="user.id">
          <td>{{ user.id }}</td>
          <td>{{ user.userName }}</td>
          <td>{{ user.isAdmin }}</td>
          <td>{{ user.department }}</td>
          <td>{{ user.name }}</td>
          <td>{{ user.phone }}</td>
          <td>{{ user.mail }}</td>
          <td>
            <span class="status-dot" :class="{'status-normal': user.zhuangtai === '正常', 'status-abnormal': user.zhuangtai !== '正常'}"></span>
            {{ user.zhuangtai }}
          </td>
          <td>
            <button class="delete-button" @click="deleteAdmin(user.id)">删除</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 添加管理员模态框 -->
    <div v-if="showAddAdminModal" class="modal-overlay">
      <div class="modal">
        <h3>选择用户添加为管理员</h3>
        <input type="text" placeholder="搜索用户" v-model="searchNonAdminUser" @input="filterNonAdminUsers" />
        <ul>
          <li v-for="user in filteredNonAdminUsers" :key="user.id" 
              :class="{'selected': selectedUser && selectedUser.id === user.id}"
              @click="selectUser(user)">
            {{ user.name }} ({{ user.userName }})
          </li>
        </ul>
        <button class="confirm-button" @click="addAdmin">确认</button>
        <button class="cancel-button" @click="closeAddAdminModal">取消</button>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  data() {
    return {
      searchUsername: '',
      searchEmail: '',
      users: [],
      showAddAdminModal: false,
      searchNonAdminUser: '',
      selectedUser: null,
      nonAdminUsers: [],
      filteredNonAdminUsers: []
    };
  },
  computed: {
    filteredUsers() {
      return this.users.filter(user => {
        const isAdmin = user.isAdmin === '是';
        const matchesUsername = this.searchUsername ? user.userName.includes(this.searchUsername) : true;
        const matchesEmail = this.searchEmail ? user.mail.includes(this.searchEmail) : true;
        return isAdmin && matchesUsername && matchesEmail;
      });
    }
  },
  methods: {
    async fetchUsers() {
      try {
        const response = await this.$axios.get('/api/show_tongxunlu');
        const data = response.data;
        if (data.code === 0) {
          this.users = data.data;
        } else {
          console.error('Failed to fetch users:', data.message);
        }
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    },
    search() {
      // 搜索逻辑已经在 computed 属性中实现
    },
    clear() {
      this.searchUsername = '';
      this.searchEmail = '';
    },
    async deleteAdmin(id) {
      if (confirm('确定要删除该管理员吗？')) {
        try {
          const response = await this.$axios.post('/api/delete_admin', {
            id: id
          });
          const data = response.data;
          if (data.code === 0) {
            this.$message.success({
            message: '管理员删除成功',
            duration: 2000
          });
            this.fetchUsers(); // 刷新用户列表
          } else {
            this.$message.error({
            message: '管理员删除失败',
            duration: 2000
          });
          }
        } catch (error) {
          console.error('Error deleting admin:', error);
        }
      }
    },
    openAddAdminModal() {
      this.showAddAdminModal = true;
      this.fetchNonAdminUsers();
    },
    closeAddAdminModal() {
      this.showAddAdminModal = false;
      this.selectedUser = null;
      this.searchNonAdminUser = '';
    },
    async fetchNonAdminUsers() {
      try {
        const response = await this.$axios.get('/api/show_tongxunlu');
        const data = response.data;
        if (data.code === 0) {
          this.nonAdminUsers = data.data.filter(user => user.isAdmin !== '是');
          this.filteredNonAdminUsers = this.nonAdminUsers;
        } else {
          console.error('Failed to fetch non-admin users:', data.message);
        }
      } catch (error) {
        console.error('Error fetching non-admin users:', error);
      }
    },
    selectUser(user) {
      this.selectedUser = user;
    },
    filterNonAdminUsers() {
      this.filteredNonAdminUsers = this.nonAdminUsers.filter(user => {
        return user.name.includes(this.searchNonAdminUser) || user.userName.includes(this.searchNonAdminUser);
      });
    },
    async addAdmin() {
      if (this.selectedUser) {
        try {
          const response = await this.$axios.post('/api/add_admin', {
            id: this.selectedUser.id
          });
          const data = response.data;
          if (data.code === 0) {
            this.$message.success({
            message: '添加管理员成功',
            duration: 2000
          });
            this.closeAddAdminModal();
            this.fetchUsers(); // 刷新用户列表
          } else {
            this.$message.error({
            message: '添加管理员失败',
            duration: 2000
          });
          }
        } catch (error) {
          console.error('Error adding admin:', error);
        }
      } else {
        this.$message({
            message: '请选择一个用户',
            duration: 2000
          });
      }
    }
  },
  mounted() {
    this.fetchUsers();
  }
};
</script>

<style scoped>
.user-table-container {
  padding: 20px;
}

.search-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.search-bar input,
.search-bar button {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.search-button {
  background-color: #4CAF50;
  color: white;
}

.clear-button {
  background-color: #ff9800;
  color: white;
}

.add-admin-button {
  background-color: #2196F3;
  color: white;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
}

.status-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}

.status-normal {
  background-color: #28a745;
}

.status-abnormal {
  background-color: #dc3545;
}

.delete-button {
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal h3 {
  margin-top: 0;
  margin-bottom: 10px;
}

.modal input {
  width: 100%;
  margin-bottom: 10px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.modal ul {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
}

.modal li {
  cursor: pointer;
  padding: 5px;
  background: #f9f9f9;
  margin-bottom: 5px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.modal li:hover {
  background: #e9e9e9;
}

.modal li.selected {
  background: #d1ecf1;
  color: #0c5460;
}

.confirm-button {
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
}

.cancel-button {
  background-color: #ff9800;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>